import {
  SearchableSelect,
  type SearchableSelectProps,
} from "@spz/ui/components/searchable-select";

export type SelectFieldProps = SearchableSelectProps<string | number>;

export function SelectField(props: SelectFieldProps) {
  return <SearchableSelect {...props} />;
}
